import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ListadoComponent } from './components/generalList/generallist.component';
import { CustomBlockAtributoComponent } from './components/customAttributeBlock/customBlockAttribute.component';
import { Base64Directive } from './directives/base64.directive';
import { KeyValueBuilderComponent } from './components/kevValueBuilder/keyValueBuilder.component';
import { DragulaModule } from 'ng2-dragula/components/dragular.module';
import { DataTableComponent } from './components/dataTable/dataTable.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MomentModule } from 'angular2-moment/moment.module';
import { LoaderComponent } from './components/loader/loader.component';
import { ListadoChannelsComponent } from '../private/channels/listado.channels.component';
import { ProductListComponent } from '../private/product/product.list.component';
import { ImageCropperComponent } from './components/fileUpload/imageCropper.component';
import { ListFileManagerComponent } from './components/listFilesManager/listFilesManager.component';

import { ImageCropperModule } from 'ngx-image-cropper';
import { Ng4JsonEditorModule } from 'angular4-jsoneditor';
import { EliminarEntidadComponent } from './components/deleteEntity/deleteEntity.component';
import { ConfirmacionModalComponent } from './components/confirmationModal/confirmationModal.component';
import { ExportModalComponent } from './components/exportModal/exportModal.component';
import { ImportModalComponent } from './components/importModal/importModal.component';
import { BuscadorPipe } from './pipes/buscador.pipe';
import { InputComponent } from './components/formWidgets/input.component';
import { ProgressBarComponent } from './components/progressBar/progressbar.component';
import { TrackingComponent } from './components/formWidgets/tracking.component';
import { ImageUploaderComponent } from './components/fileUpload/imageUploader.component';
import { TextAreaComponent } from './components/formWidgets/textArea.component';
import { EntityStatusComponent } from './components/formWidgets/entityStatus.component';
import { SelectorCategoriasComponent } from './components/categorySelector/categorySelector.component';
import { TemplateListadoComponent } from './components/templateList/templateList.component';
import { SelectorMultipleComponent } from './components/selectorMultiple/selectorMultiple.component';
import { ToMultipleSelectPipe } from './pipes/toMultipleSelect.pipe';
import { CurrencyTransform } from './pipes/currencyTransform.pipe';
import { AttributeNameTransform } from './pipes/attributeNameTransform.pipe';
import { Base64ImagePipe } from './pipes/image.pipe';
import { sxFileImportComponent } from './components/sxFileImport/fileImport.component';
import { HumanizePipe } from './pipes/humanize.pipe';
import { MetadataComponent } from 'app/private/atributos/metadata/metadata.component';
import { DocumentTypesPipe } from './pipes/documentTyper.pipe';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { EnumKeyValueListPipe } from './pipes/enumKeyValueList.pipe';
import { ComparisonOperator } from './pipes/comparisonOperator.pipe';
import { ValueBuilderComponent } from './components/valueBuilder/valueBuilder.component';
import { MappingAttributeComponent } from './components/mappingAttribute/mappingAttribute.component';
import { AceEditorModule } from 'ng2-ace-editor';
import { CrudListBuilderComponent } from './components/crudListBuilder/crudListBuilder.component';
import { UppercaseDirective } from './directives/uppercase.directive';
import { CountryTransform } from './pipes/country.pipe';
import { CategoryModalComponent } from './components/category/categoryModal.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { BrowserModule } from '@angular/platform-browser';
import { I18NextModule } from 'angular-i18next';

const componentes = [
  ListFileManagerComponent,
  ListadoComponent,
  CustomBlockAtributoComponent,
  Base64Directive,
  KeyValueBuilderComponent,
  DataTableComponent,
  LoaderComponent,
  ListadoChannelsComponent,
  ProductListComponent,
  ImageCropperComponent,
  EliminarEntidadComponent,
  ConfirmacionModalComponent,
  ExportModalComponent,
  ImportModalComponent,
  BuscadorPipe,
  InputComponent,
  ProgressBarComponent,
  TrackingComponent,
  ImageUploaderComponent,
  TextAreaComponent,
  EntityStatusComponent,
  sxFileImportComponent,
  SelectorCategoriasComponent,
  TemplateListadoComponent,
  SelectorMultipleComponent,
  ToMultipleSelectPipe,
  CurrencyTransform,
  AttributeNameTransform,
  Base64ImagePipe,
  HumanizePipe,
  DocumentTypesPipe,
  MetadataComponent,
  EnumKeyValueListPipe,
  ComparisonOperator,
  ValueBuilderComponent,
  CrudListBuilderComponent,
  UppercaseDirective,
  MappingAttributeComponent,
  CountryTransform,
  CategoryModalComponent
];

@NgModule({
  imports: [
    AceEditorModule,
    FormsModule,
    CommonModule,
    RouterModule,
    DragulaModule,
    NgbModule.forRoot(),
    MomentModule,
    ImageCropperModule,
    Ng4JsonEditorModule,
    SelectDropDownModule,
    NgxSmartModalModule.forRoot(),
    I18NextModule
  ],
  exports: componentes,
  declarations: componentes,
  entryComponents: [ImageCropperComponent, ConfirmacionModalComponent, ExportModalComponent, ImportModalComponent],
  providers: [ ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/shared.module.ts